// Tab labels for URL sync (lowercase for URL, matches order of tabItems)
export enum CampaignOverviewTab {
  OVERVIEW = 'overview',
  COMMUNICATION = 'communication',
  CONTACTS = 'contacts',
  ACTIVITY = 'activity',
  SETTINGS = 'settings',
}
